import clsx from 'clsx'
import {useEffect, useState, useCallback, useRef} from 'react'
import {useAuth} from '../../../../app/modules/auth'
import {KTSVG} from '../../../helpers'
import {TutorialChecklist} from '../../../../app/modules/orders'
import {TUTORIAL_CARDS} from '../../../../app/modules/orders/core/_const'
import UserService from '../../../../app/modules/users/core/_requests'
import {TUTORIAL_CHECKLIST_TOGGLE_ID} from '../../../constants'

const ChecklistButton = () => {
  const {currentUser} = useAuth()
  const [showChecklist, setShowChecklist] = useState(false)
  const [tutorialCard, setTutorialCard] = useState(null)
  const [stepsCompleted, setStepsCompleted] = useState(5)
  const checklistCloseRef = useRef<() => void | null>(null)

  const handleShowChecklist = () => {
    if (showChecklist) {
      // Use the closeChecklist function from the ref to trigger the animation
      if (checklistCloseRef.current) {
        checklistCloseRef.current()
      } else {
        // Fallback to the old behavior if the ref is not set
        setShowChecklist(false)
      }
    } else {
      setShowChecklist(true)
    }
  }

  const closeChecklist = () => {
    setShowChecklist(false)
  }

  useEffect(() => {
    const fetchTutorialCard = async () => {
      if (!currentUser) return

      try {
        const settings = await UserService.getTutorialCard()
        setTutorialCard(settings)
      } catch (error) {
        console.error('Error fetching tutorial card:', error)
      }
    }

    fetchTutorialCard()
  }, [currentUser])

  const countStepsCompleted = useCallback(() => {
    let completedCount = 0

    TUTORIAL_CARDS.forEach((card) => {
      const isCompletedCardClosed = currentUser?.user_profiles?.tutorial_cards?.some(
        (userCard) => userCard.card_key === card.key && !userCard.is_show
      )
      const key = 'card' + card.key
      const isCompletedInLocalStorage = isCompletedCardClosed
        ? true
        : localStorage.getItem(key) !== null

      const isCompletedBySetting = isCompletedInLocalStorage
        ? true
        : tutorialCard
        ? tutorialCard[card.key]
        : false

      if (isCompletedBySetting) {
        completedCount += 1
      }
    })
    return completedCount
  }, [currentUser, tutorialCard])

  useEffect(() => {
    if (!currentUser || !tutorialCard) return

    const handleStorageChange = () => {
      let completedCount = countStepsCompleted()
      setStepsCompleted(5 - completedCount)
    }
    window.addEventListener('storage', handleStorageChange)
    return () => {
      window.removeEventListener('storage', handleStorageChange)
    }
  }, [currentUser, tutorialCard, countStepsCompleted])

  useEffect(() => {
    if (!currentUser || !tutorialCard) return

    let completedCount = countStepsCompleted()
    setStepsCompleted(5 - completedCount)
  }, [currentUser, tutorialCard, countStepsCompleted])

  if (!currentUser) return null

  return (
    <div className='topbar-dropdown topbar-dropdown--checklist'>
      <button
        type='button'
        className={clsx(
          'btn p-0 ms-2 position-relative topbar-icon-button topbar-icon-button--checklist',
          {
            'topbar-icon-button--active': showChecklist,
          }
        )}
        onClick={() => handleShowChecklist()}
        id={TUTORIAL_CHECKLIST_TOGGLE_ID}
        aria-expanded={showChecklist}
        aria-haspopup='dialog'
      >
        <KTSVG
          path='/media/gori/topbar/list-icon.svg'
          className='desktop-only-menu-item'
          small={false}
        />
        {stepsCompleted > 0 && (
          <div className='tutorial-checklist-badge d-inline-flex align-items-center justify-content-center position-absolute p-2'>
            <span className='tutorial-checklist-badge-text m-0 text-center fw-bold'>
              {stepsCompleted}
            </span>
          </div>
        )}
      </button>

      {showChecklist && (
        <TutorialChecklist closeChecklist={closeChecklist} closeRef={checklistCloseRef} />
      )}
    </div>
  )
}

export {ChecklistButton}
